import React, { ComponentType, useState, useEffect, ReactNode, useContext } from 'react';

const InvariantContext = React.createContext<boolean>(false);

interface InvariantProviderProps {
    isHydrated: boolean;
    children: ReactNode;
}

export const InvariantProvider = (props: InvariantProviderProps) => {
    const { isHydrated, children } = props;
    const [initialRenderComplete, setInitialRenderComplete] = useState(!isHydrated);

    useEffect(() => {
        setInitialRenderComplete(true);
    }, [isHydrated, setInitialRenderComplete]);

    return (
        <InvariantContext.Provider value={initialRenderComplete}>
            {children}
        </InvariantContext.Provider>
    );
};

export function withInvariant<TProps extends {}>(
    CSRComponent: ComponentType<TProps>,
    SSRComponent: ComponentType<TProps>,
) {
    return (props: TProps) => {
        const initialRenderComplete = useContext(InvariantContext);

        if (typeof window === 'undefined' || !initialRenderComplete) {
            return <SSRComponent {...props} />;
        }

        return <CSRComponent {...props} />;
    };
}
